module.exports = __webpack_public_path__ + "static/media/header01.05a8f02d.png";